import {
  GET_PLC_SAFETY_TRIGGER_BY_ID,
  GET_PLC_SAFETY_TRIGGER_BY_ID_SUCCESS,
  GET_PLC_SAFETY_TRIGGER_BY_ID_ERROR,
} from './actionTypes';

const initialState = {
  errorGetPlcSafetyTriggerById: '',
  loadingGetPlcSafetyTriggerById: false,
  trigger: null,
};

const getTriggerById = (state = initialState, action) => {
  switch (action.type) {
    case GET_PLC_SAFETY_TRIGGER_BY_ID:
      state = { ...state, loadingGetPlcSafetyTriggerById: true };
      break;
    case GET_PLC_SAFETY_TRIGGER_BY_ID_SUCCESS:
      state = { ...state, loadingGetPlcSafetyTriggerById: false, trigger: action.payload.trigger };
      break;
    case GET_PLC_SAFETY_TRIGGER_BY_ID_ERROR:
      state = { ...state, errorGetPlcSafetyTriggerById: action.payload, loadingGetPlcSafetyTriggerById: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getTriggerById;
